
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuthenticated } from '../hooks/useAuthenticated';

const GuestGuard = ({ children }) => {
  const auth = useAuthenticated();
  const { search } = useLocation();

  if (auth) {
    const raw = new URLSearchParams(search).get('redirect');
    const redirectPath = raw && raw.startsWith('/') ? raw : '/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default GuestGuard;